// extracted by mini-css-extract-plugin
module.exports = {"container":"CookieBar_container__Ty16d","text":"CookieBar_text__7Q_QN","buttonContainer":"CookieBar_buttonContainer__WwkEM"};